/**
 * Created by cbikar on 2/2/2016.
 */
define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var CoBrowseConfigEditView = require("personalization-web-agent-views/CoBrowseConfigEditView");
    var Settings = require("codeTables/settings.json");

    var CoBrowseConfigEditController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {


        CoBrowseConfigEditController = BaseFeatureController.extend({


            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "CoBrowseConfigEditController:_initialize");
                this.settingsCollection = options.settingsCollection;

                this._createView(options);
                this._bindEvents();
            },


            getEditView: function () {
                return this._getEditView();
            },

            _createView: function (options) {
                LEPersonalization.logger.debug("create the edit view", "CoBrowseConfigEditController:_createView");

                this.coBrowseConfigEditView = new CoBrowseConfigEditView({
                    settingsCollection: options.settingsCollection
                });

            },

            _bindEvents: function () {
                LEPersonalization.logger.debug("binding events", "CoBrowseConfigEditController:_bindEvents");
                this.listenTo(this.coBrowseConfigEditView, "coBrowseConfig:save", this._onSave);
                this.listenTo(this.coBrowseConfigEditView, "coBrowseConfig:cancel", this._onCancel);
            },

            _saveSiteSettings: function (options) {
                options = options || [];
                LEPersonalization.logger.debug("save site settings", "CoBrowseConfigEditController:_saveSiteSettings.");
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_DISABLED).setValue(options[Settings.SETTING_ID.COBROWSE_DISABLED]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_AGENTPROFILE).setValue(options[Settings.SETTING_ID.COBROWSE_AGENTPROFILE]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE).setValue(options[Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_AGENTRESIZE).setValue(options[Settings.SETTING_ID.COBROWSE_AGENTRESIZE]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_BORDERCOLOR).setValue(options[Settings.SETTING_ID.COBROWSE_BORDERCOLOR]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_HIGHLIGHTCOLOR).setValue(options[Settings.SETTING_ID.COBROWSE_HIGHLIGHTCOLOR]);
                this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_MASKEDFIELDS).setValue(options[Settings.SETTING_ID.COBROWSE_MASKEDFIELDS]);

                this.settingsCollection.update({
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSave: function (options) {
                LEPersonalization.logger.info("save button clicked", "CoBrowseConfigEditController:_onSave");

                LEPersonalization.loader.setLoader();
                this._saveSiteSettings(options);
            },


            _onSaveSuccess: function (model) {
                LE.siteSettings.cobrowseSettings.setValuesFromModel(model);

                LEPersonalization.logger.info("config was saved successfully", "CoBrowseConfigEditController:_onSaveSuccess");
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToPageMenu();
            },

            _onSaveError: function (response) {
                LEPersonalization.logger.debug("When data fetch has resulted with an error", "CoBrowseConfigEditController:_onSaveError. response = " + response);
                this._showNotifierError(response);
                LEPersonalization.loader.closeLoader();
            },

            _onCancel: function () {
                LEPersonalization.logger.info("cancel was clicked", "CoBrowseConfigEditController:_onCancel");
                LEPersonalization.navigateToPageMenu();
            },

            _getEditView: function () {
                return this.coBrowseConfigEditView;
            }


        });
    });
    return CoBrowseConfigEditController;

});
